<template>
  <v-container class="gray pa-3 ma-0 fluid subtitle-1 text-justify">
    <h1 class="mt-4">Porque Wails? Quais as opções para usar Wails?</h1>
    <br />
    <v-layout>
      <v-flex>
        <v-row>
          <v-col class="col-10 offset-1">
            <p>
              Wails é uma excelente maneira de fazer um aplicativo bonito, com interface HTML/CSS/Javascript, com possibilidade de falar
              com servidores, acessar banco de dados e conversar com hardware local.
            </p>

            <p>Precisa ser tudo em um programa só? Claro que não!</p>

            <p>Vamos ver alguns possíveis casos de uso...</p>

            <p>
              <strong>Caso de uso mais simples</strong>: o programa é usado apenas localmente, sem acessar nada além da máquina local.
            </p>

            <p>
              Wails é perfeito para isso. Interface gráfica bonita, e o backend em Go pode fazer o que for necessário, inclusive acessar um
              banquinho de dados local (como o SQLite, por exemplo) ou arquivos textos (visualizador de logs, transformar aquivos de um formato
              para outro, copiar arquivos de uma pasta para outra, etc). Ou seja, infinitas possibilidades. O programa pode até mesmo ser
              instalado em um pen drive...
            </p>

            <p>
              <strong>Segundo caso de uso (e provavelmente muito comum de ocorrer)</strong>: o programa executa em várias máquinas da rede interna,
              mas todas acessam o mesmo banco de dados, armazenado em um servidor da rede.
            </p>

            <p>
              Faça um programa controlador de acessos ao banco de dados. Todos os acessos aos dados passam por ele, que recebe pedidos
              e devolve respostas na conversa com os programas clientes.
            </p>

            <p>
              Como faço esse servidor? Simples. Go permite facilmente criar um servidor HTTP. Seu programa em Wails envia a solicitação para a
              API do servidor, que acessa o banco, recupera os dados e os envia como resposta da solicitação original. O Wails recebe a resposta e
              age de acordo, seja apresentando um erro ao usuário ("Produto não cadastrado", etc) ou processando os dados retornados.
            </p>

            <p>
              Essa arquitetura tem duas vantagens: se você não quiser fazer esse servidor em Go, pode usar qualquer outra tecnologia confortável: Java,
              Php, Spring, Groovy, etc. Até mesmo Cobol. Apenas sugiro Go porque ele não precisa de JDK, máquina virtual nem nada do estilo. Apenas
              um executável nativo é gerado, sem dependências externas, o que facilita muito a instalação em clientes (é só copiar e sair executando).
            </p>

            <p>
              A segunda vantagem é que o frontend não precisa ser Wails. O servidor recebe solicitações e devolve respostas. Qualquer linguagem que
              fale protocolo HTTP/HTTPS pode enviar e receber dados de/para este servidor. O frontend pode ser Cobol, Java, um site da Web, etc.
            </p>

            <p>
              <strong>Mas vou ter que aprender uma linguagem Web?</strong>
            </p>

            <p>
              Bem, essa é a base da utilização do Wails. Não considero isso uma desvantagem por que, gostemos ou não, saber HTML/CSS/Javascript é
              fundamental hoje em dia. Além do mais, sabendo criar algo em uma linguagem Web, a parte frontend do sistema, feito inicialmente
              para ser executado via Wails pode facilmente ser publicada em um site na Internet. Seu sistema pode ter uma versão Web permitindo
              algumas coisas e uma versão Wails permitindo outras. Por exemplo, podem ser permitidas apenas consultas via versão Web, enquanto
              que a entrada de dados para o sistema seria feita localmente na versão Wails.
            </p>

            <p>
              <strong>Qual linguagem Web devo usar?</strong>
            </p>

            <p>Escolha sua. O Wails trabalha atualmente com Angular, React e Vue.</p>

            <p>Angular é o mais complexo e Vue o mais simples, sendo que React está no meio.</p>

            <p>
              Pessoalmente, eu prefiro Vue. Simples, conciso, razoavelmente fácil de aprender e faz tudo o que é necessário. Adicionalmente, VueJs
              pode utilizar um
              <i>framework</i> adicional chamado Vuetify, que é uma biblioteca de classes CSS prontas que tornam mais simples a programação
              visual da aplicação. Este site, por exemplo, foi desenvolvido utilizando Vue e Vuetify...
            </p>

            <p>Note a barra superior da tela. Ela fica fixa no topo da página, mesmo que o conteúdo da página tenha rolagem.</p>

            <p>
              Note também o botão verde no canto inferior direito da tela. Este botão rola a página para o topo da mesma, e assim como a
              barra superior sua posição é fixa.
            </p>

            <p>
              Veja também o ícone com as três linhas no canto esquerdo da barra superior. Ao clicar nele, se abre uma barra lateral com links para
              as diferentes páginas do site. Clicando novamente nele, esta barra lateral se recolhe.
            </p>

            <p>
              Tudinho feito com Vue e Vuetify! Fácil de fazer! Levei 1% do tempo gasto neste site para montar esta estrutura geral. Os outros 99% foram
              gastos escrevendo o texto...
            </p>

            <p>
              Esta estrutura de página poderia ser usada pelo seu sistema. Barra superior fixa (pode ser um menu),
              barra lateral que se recolhe e que pode ter o link para cada uma das partes do sistema, etc.
              Enfim, as possibilidades são limitadas pela sua imaginação.
            </p>

            <p>
              <strong>Resumindo</strong>:
            </p>

            <p>
              Quando sugiro a utilização do Wails, a principal razão é manter todo o código da lógica e das regras de negócio "escondidas" dos olhos
              dos usuários.
            </p>

            <p>
              Mas existem diversas opções e casos de usos que podem ser gerados com as tecnologias que estamos vendo aqui. Cada caso é uma caso, e estou
              aqui para auxiliar.
            </p>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="col-1 offset-9">
            <v-btn class="primary" to="/install">Montagem do ambiente</v-btn>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <v-btn fab dark large color="success" fixed right bottom @click="GoTop()">
      <v-icon dark>mdi-arrow-up-bold</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "Options",
  mounted() {
    this.$vuetify.goTo(0);
  },
  methods: {
    GoTop() {
      this.$vuetify.goTo(0);
    }
  }
};
</script>
